export const nameAttribute = "data-rc-id";

export interface IBuildRCAttribute {
    [nameAttribute]: string;
  }

export const BuildRCAttribute = (value: string): IBuildRCAttribute => {
    return { [nameAttribute]: value };
  };